
import Vue from 'vue'
import FooterMenu from './footer-menu/index.vue'

export default Vue.extend({
  components: {
    FooterMenu
  },
  props: {
    /**
     * Массив деревьев ссылок
     */
    sections: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  computed: {
    filteredSections () {
      return this.sections?.filter((section: { showInFooter?: boolean }) => (section?.showInFooter ?? true)) || []
    }
  }
})
